export const LOGIN = () => "/auth/login";
export const CHANGE_USER = () => "/auth/user/change";
export const LOGOUT = () => "/auth/logout";
export const CHANGE_PASSWORD = () => "/auth/user/change-password";
export const REFRESH_TOKEN = () => "/auth/refresh";
export const GET_USER = () => "/auth/user";
export const GET_USERS = () => "/auth/user/list";
export const BASKET_DELETE_ITEM = () => "/monolithic/baskets/delete-item";
export const BASKET_ADD_ITEM = () => "/monolithic/baskets/add-item";
export const BASKET_GET_ITEMS = () => "/monolithic/baskets/get-items";
export const BASKET_GET_ITEM_IDS = () => "/monolithic/baskets/get-items-id";
export const BASKET_COUNT_ITEMS = () => "/monolithic/baskets/count-items";
export const BASKET_DELETE = () => "/monolithic/baskets";
export const ALREADY_LOGGEDIN = () => "/user/alreadyLogin";
